<template>
  <div>
    <v-row no-gutters style="padding: 0">
      <v-col cols="12" style="padding: 15px">
        <v-form
          ref="entryForm"
          @submit.prevent="submitForm"
          :disabled="loading"
        >
          <v-card
            flat
            :style="`${
              wWidth > 992 ? 'border-bottom: 1px solid black;' : ''
            } margin-bottom: 20px`"
          >
            <div class="position-relative" style="height: 25px">
              <router-link to="/asset-management/pemindahan-aset">
                <v-btn
                  text
                  color="black"
                  class="black--text font-weight-bold"
                  x-small
                  type="button"
                  outlined
                  style="position: absolute; right: 0; top: -10px"
                  :loading="loading"
                  :disabled="loading"
                >
                  <v-icon x-small>mdi-chevron-left</v-icon>
                  Kembali
                </v-btn>
              </router-link>
            </div>
            <div
              :class="`d-flex ${
                wWidth > 992 ? 'justify-space-between' : 'justify-center'
              }`"
            >
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-left: 10px;
                "
              >
                <v-toolbar-title class="overline">
                  <p style="font-size: 20px; margin: 0; font-weight: bold">
                    Formulir Pemindahan Aset
                  </p>
                </v-toolbar-title>
              </div>
              <v-btn
                v-if="wWidth > 992"
                :loading="loading"
                :disabled="loading"
                type="submit"
                elevation="0"
                color="primary"
                class="white--text font-weight-bold ma-1"
                style="font-size: 12px"
                small
              >
                Simpan
              </v-btn>
            </div>
          </v-card>

          <v-expansion-panels
            v-model="panel"
            multiple
            class="mb-10 pt-5"
            elevation="1"
          >
            <v-expansion-panel>
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                style="font-weight: bold"
              >
                Informasi Umum
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row style="padding: 15px; margin-top: 10px">
                  <v-col cols="12" md="3" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          PIC
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          :value="getUserProfile.employee.name"
                          dense
                          readonly
                          style="margin: 0"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="3" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Plant
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          :value="getUserProfile.employee.company.name"
                          dense
                          readonly
                          style="margin: 0"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="3" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Department
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          :value="getUserProfile.employee.department.name"
                          dense
                          readonly
                          style="margin: 0"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="3" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Email
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          :value="getUserProfile.employee.email"
                          dense
                          readonly
                          style="margin: 0"
                        />
                      </v-col>
                    </div>
                  </v-col>
                </v-row>

                <v-row style="padding: 15px; margin-top: 10px">
                  <v-col cols="12" md="3" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tgl Pemindahan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          v-model="form.schedule_from"
                          clearable
                          outlined
                          dense
                          type="date"
                          name="date"
                          step="1"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="3" style="padding: 0">
                    <div v-if="!form.is_sell" style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tgl. Pengembalian
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-text-field
                          v-model="form.schedule_to"
                          clearable
                          outlined
                          dense
                          type="date"
                          name="date"
                          step="1"
                        />
                      </v-col>
                    </div>
                  </v-col>
                  <v-col cols="12" md="3" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="12" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Destinasi
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-autocomplete
                          v-model="form.destination"
                          :items="getDropdownCompany"
                          item-text="name"
                          item-value="id"
                          return-object
                          outlined
                          dense
                          style="margin: 0"
                        ></v-autocomplete>
                      </v-col>
                    </div>
                  </v-col>
                  <!-- is_sell checkbox -->
                  <!-- <v-col md="3" style="padding: 0">
            <div style="padding: 0 10px">
              <v-radio-group>
                <v-col
                  cols="12"
                  style="
                    padding: 0;
                    justify-content: flex-start;
                    align-items: center;
                    display: flex;
                  "
                >
                  <p
                    style="
                      margin: 0 10px 0 0;
                      font-size: 14px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Jual
                  </p>
                  <v-checkbox
                    v-model="form.is_sell"
                    style="margin: 0; height: 25px; padding: 0"
                  ></v-checkbox>
                </v-col>
              </v-radio-group>
            </div>
          </v-col> -->

                  <!-- <v-col md="2" style="padding: 0">
            <div style="padding: 0 10px">
              <v-col cols="4" style="padding: 0">
                <p
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Total Item
                </p>
              </v-col>
              <v-col cols="12" style="padding: 0;">
                <v-text-field
                  v-model="form.total_item"
                  type="number"
                  dense
                  outlined
                  disabled
                  style="margin: 0; "
                />
              </v-col>
            </div>
          </v-col> -->
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- if is_sell is true -->
            <!-- <v-row v-if="form.is_sell" style="padding: 15px; margin-top: 10px">
          <v-col md="3" style="padding: 0">
            <div style="padding: 0 10px">
              <v-col cols="4" style="padding: 0">
                <p
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Upload File
                </p>
              </v-col>
              <v-col cols="12" style="padding: 0">
                <v-file-input
                  ref="assetDocUpload"
                  @change="uploadFile"
                  :label="
                    form.sales_document != ''
                      ? form.sales_document
                      : '- browse file -'
                  "
                  prepend-icon=""
                  outlined
                  dense
                  :disabled="isUpload"
                ></v-file-input>
              </v-col>
            </div>
          </v-col>
          <v-col md="3" style="padding: 0 0 10px 0; margin: auto; margin-left: 0">
            <v-progress-circular
              v-if="isUpload"
              color="primary"
              indeterminate
              :width="3"
              :size="25"
            ></v-progress-circular>
            <p
              v-if="uploadMessage.length > 0"
              :style="`font-size:10px; margin:auto; color:${uploadMessage[2]}; font-weight:bolder;`"
            >
              {{ uploadMessage[1] }}
              <v-icon v-if="uploadMessage[0] == 'suuccess'" color="green"
                >mdi-check</v-icon
              >
            </p>
          </v-col>
        </v-row> -->

            <v-expansion-panel v-if="wWidth > 992">
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                style="font-weight: bold"
              >
                Barang yang dipindahkan
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row style="padding: 15px">
                  <v-col md="12" style="padding: 0 10px">
                    <v-card
                      flat
                      style="
                        top: 0;
                        background: white;
                        margin-top: 20px;
                        margin-bottom: 40px;
                      "
                    >
                      <v-btn
                        v-if="wWidth > 992"
                        elevation="2"
                        small
                        @click="addItem"
                        rounded
                        outlined
                        color="indigo"
                        class="indigo--text font-weight-bold ma-2"
                        style="font-size: 12px; margin-bottom: 5px"
                      >
                        add item</v-btn
                      >
                      <v-data-table
                        height="30vh"
                        mobile-breakpoint="600"
                        :headers="headers"
                        :items="form.items"
                        class="elevation-1 mx-auto"
                        style="
                          width: 100%;
                          margin-bottom: 10px;
                          border: 1px solid #e0e0e0;
                        "
                        :items-per-page="10"
                        hide-default-footer
                      >
                        <template v-slot:[`header.action`]>
                          <span
                            >Aksi
                            <v-tooltip bottom>
                              <template v-slot:activator="{ attrs, on }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="red lighten-2"
                                  style="margin: 0"
                                  x-small
                                  @click="removeAll"
                                  :disabled="form.items.length == 0"
                                >
                                  mdi-delete-circle
                                </v-icon>
                              </template>
                              <span>Delete All</span>
                            </v-tooltip>
                          </span>
                        </template>
                        <template v-slot:[`item.name`]="{ item }">
                          <div
                            style="font-size: 12px; width: 160px; padding: 0"
                          >
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:[`item.lot_no`]="{ item }">
                          <div style="font-size: 12px; width: 60px; padding: 0">
                            {{ item.lot_no }}
                          </div>
                        </template>
                        <template v-slot:[`item.company_name`]="{ item }">
                          <div
                            style="font-size: 12px; width: 210px; padding: 0"
                          >
                            {{ item.company_name }}
                            <!-- / {{ item.location_name }} -->
                          </div>
                        </template>
                        <template
                          v-slot:[`item.current_location_name`]="{ item }"
                        >
                          <div
                            style="font-size: 12px; width: 210px; padding: 0"
                          >
                            {{
                              item.current_company_name +
                              ' - ' +
                              item.current_location_name
                            }}
                          </div>
                        </template>
                        <template v-slot:[`item.qty_available`]="{ item }">
                          <div style="font-size: 12px; width: 60px; padding: 0">
                            {{ item.qty_available }}
                          </div>
                        </template>
                        <template v-slot:[`item.qty_move`]="{ item }">
                          <div style="padding: 0">
                            <div style="height: 40px; width: 90px">
                              <v-text-field
                                v-model="item.qty"
                                dense
                                outlined
                                type="number"
                                min="0"
                                max="9999"
                                :rules="[
                                  (v) => v >= 0 || 'Min 0',
                                  (v) => v <= 9999 || 'Max 9999'
                                ]"
                              />
                            </div>
                          </div>
                        </template>
                        <template v-slot:[`item.action`]="{ item, index }">
                          <div style="font-size: 12px; width: 40px; padding: 0">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ attrs, on }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  text
                                  icon
                                  x-small
                                  color="red lighten-2"
                                  @click="remove(item, index)"
                                >
                                  <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Delete</span>
                            </v-tooltip>
                          </div>
                        </template>
                        <template v-slot:[`item.note`]="{ item }">
                          <div style="padding: 0">
                            <div style="height: 40px; width: 220px">
                              <v-text-field
                                v-model="item.note"
                                dense
                                outlined
                                type="text"
                              />
                            </div>
                          </div>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="wWidth < 992">
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                style="font-weight: bold"
              >
                <div class="d-flex">
                  Barang yang dipindahkan
                  <span
                    v-if="form"
                    style="
                      font-size: 9px;
                      font-weight: normal;
                      margin-left: 2px;
                    "
                  >
                    ({{ form.items.length }})
                  </span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="form != null && form.items.length > 0">
                  <v-row no-gutters style="padding: 0">
                    <v-col
                      v-for="(item, index) in form.items"
                      :key="index"
                      cols="12"
                      md="6"
                      style="padding: 0"
                    >
                      <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-menu-down">
                          <div class="d-flex">
                            <div
                              style="font-size: 12px; width: 40px; padding: 0"
                            >
                              <v-tooltip bottom>
                                <template v-slot:activator="{ attrs, on }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    text
                                    icon
                                    x-small
                                    color="red lighten-2"
                                    @click="remove(item, index)"
                                  >
                                    <v-icon small>mdi-delete</v-icon>
                                  </v-btn>
                                </template>
                                <span>Delete</span>
                              </v-tooltip>
                            </div>
                            <div
                              class="d-flex flex-column"
                              style="font-size: 12px"
                            >
                              <span>Lot. {{ item.lot_no || '-' }}</span>
                              <span>
                                {{ item.name || '-' }}
                              </span>
                            </div>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card
                            elevation="2"
                            tile
                            outlined
                            style="
                              padding: 10px 10px 0 10px;
                              margin-bottom: 20px;
                            "
                          >
                            <v-row no-gutters style="padding: 15px 10px">
                              <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.lot_no || '-'"
                                  readonly
                                  label="Lot"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.name || '-'"
                                  readonly
                                  label="Nama Aset"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.company_name || '-'"
                                  readonly
                                  label="Kepemilikan"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="
                                    item.current_company_name +
                                    ' - ' +
                                    item.current_location_name
                                  "
                                  readonly
                                  label="Lokasi awal"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="5" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  :value="item.qty_available"
                                  readonly
                                  label="Qty tersedia"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="2"></v-col>
                              <v-col cols="5" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  outlined
                                  v-model="item.qty"
                                  label="Qty transfer"
                                  type="number"
                                  min="0"
                                  max="9999"
                                  :rules="[
                                    (v) => v >= 0 || 'Min 0',
                                    (v) => v <= 9999 || 'Max 9999'
                                  ]"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                              <v-col cols="12" style="padding: 5px 0">
                                <v-text-field
                                  dense
                                  outlined
                                  v-model="item.note"
                                  label="Catatan"
                                  type="text"
                                  style="margin: 0; font-size: 12px"
                                />
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-col>
                  </v-row>
                </div>
                <div v-else class="d-flex justify-center align-center">
                  Belum ada daftar barang
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header
                expand-icon="mdi-menu-down"
                style="font-weight: bold"
              >
                Tujuan Pemindahan
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row style="padding: 15px">
                  <v-col md="12" style="padding: 0">
                    <div style="padding: 0 10px">
                      <v-col cols="4" style="padding: 0">
                        <p
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Tujuan Pemindahan
                        </p>
                      </v-col>
                      <v-col cols="12" style="padding: 0">
                        <v-textarea
                          v-model="form.description"
                          dense
                          auto-grow
                          outlined
                        />
                      </v-col>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <div
            style="
              position: fixed;
              z-index: 2;
              bottom: 80px;
              right: 0;
              display: flex;
              flex-direction: column;
              align-items: end;
              font-size: 12px;
            "
          >
            <v-btn
              v-if="wWidth < 992"
              @click="addItem"
              :loading="loading"
              rounded
              style="margin-top: 10px"
              elevation="0"
              class="indigo--text font-weight-bold ma-2"
            >
              <a href="#" style="font-weight: bold">Tambah Item</a>
              <v-icon color="primary" small style="margin-left: 5px"
                >mdi-plus-box</v-icon
              >
            </v-btn>
          </div>

          <v-row
            v-if="wWidth < 992"
            no-gutters
            style="
              width: 100%;
              position: fixed;
              bottom: 0;
              left: 0;
              z-index: 2;
              background: white;
            "
          >
            <v-col cols="12" class="d-flex justify-center align-center p-2">
              <v-btn
                elevation="1"
                color="blue"
                class="white--text font-weight-bold"
                style="font-size: 12px; width: 100%"
                :loading="loading"
                type="submit"
              >
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <add-item @getLot="initLot" :lotHeaders="headers" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import buildType from '../../../services/buildType'
export default {
  components: {
    AddItem: () => import('./components/AddItem')
  },
  data() {
    return {
      upload: buildType.apiURL('upload2'),
      loading: false,
      asset: buildType.apiURL('asset'),
      wWidth: window.innerWidth,
      panel: [0, 1],
      form: {
        destination: null,
        schedule_from: '',
        schedule_to: '',
        description: '',
        items: [],
        is_sell: false,
        total_item: 0,
        sales_document: ''
      },
      headers: [
        {
          text: 'Aksi',
          value: 'action',
          align: 'left',
          sortable: false
        },
        { text: 'Nama Aset', value: 'name', align: 'left', sortable: false },
        // {
        //   text: 'Kode Aset',
        //   value: 'asset_code',
        //   align: 'left',
        //   sortable: false
        // },
        { text: 'Kode Lot', value: 'lot_no', align: 'left', sortable: false },
        {
          text: 'Tersedia',
          value: 'qty_available',
          align: 'left',
          sortable: false
        },
        {
          text: 'Transfer',
          value: 'qty_move',
          align: 'left',
          sortable: false
        },
        {
          text: 'Kepemilikan',
          value: 'company_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Lokasi asal',
          value: 'current_location_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Catatan',
          value: 'note',
          align: 'left',
          sortable: false
        }
      ],

      isUpload: false,
      uploadMessage: []
    }
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getDropdownCompany'])
  },
  mounted() {
    console.log(this.getUserProfile)
    this.dropdownCompany()
    window.scrollTo(0, 0)
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  watch: {
    'form.is_sell'() {
      if (!this.form.is_sell) {
        for (let i = 0; i < this.form.items.length; i++) {
          this.form.items[i].new_lot_no = null
        }
        this.form.sales_document = null
        this.$refs.assetDocUpload.reset()
      }
    }
  },
  methods: {
    ...mapActions(['dropdownCompany', 'dropdownAsset']),
    onResize() {
      this.wWidth = window.innerWidth
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    rowClick(pItem) {
      console.log(pItem)
    },
    initLot(pItem) {
      for (let i = 0; i < pItem.length; i++) {
        console.log(pItem[i])
        const a = {
          company_id: pItem[i].company_id,
          company_name: pItem[i].company_name,
          current_location_name: pItem[i].current_location_name,
          current_company_name: pItem[i].current_company_name,
          lot_id: Number(pItem[i].id),
          lot_no: pItem[i].name,
          name: pItem[i].asset_name,
          qty: parseFloat(pItem[i].qty_move), // qty_move is used to store the qty that will be moved, while qty is used to store the available qty in the current location
          qty_available: parseFloat(pItem[i].qty), // qty is used to store the available qty in the current location
          // qty_move: parseFloat(pItem[i].qty_move),
          // qty: parseFloat(pItem[i].qty),
          note: pItem[i].note
        }
        this.form.items.push(a)
      }
    },
    addItem() {
      setTimeout(() => {
        document.getElementById('addItemMovement').click()
      }, 500)
    },
    submitForm() {
      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm.validate()) {
          self.createNewForm()
        }
      })
    },
    createNewForm() {
      const newForm = {
        act: 'add',
        destination_company_id: this.form.destination.id,
        destination_company_name: this.form.destination.name,
        schedule_from: this.form.schedule_from,
        schedule_to: this.form.schedule_to,
        description: this.form.description,
        is_sell: this.form.is_sell ? '1' : '0',
        sales_document: this.form.sales_document,
        item: this.form.items
      }
      console.log('newForm>>>', newForm)
      this.save(newForm)
    },
    save(form) {
      this.loading = true
      axios
        .post(`${this.asset}movement/save`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.$router.push(
              `/asset-management/detail-penerimaan/${res.data.created_id}`
            )
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              let xFlag = false
              if (res.data.error_msg !== undefined) {
                if (res.data.error_msg !== null) {
                  if (res.data.error_msg.length > 0) {
                    this.showMsgDialog(
                      'error',
                      `${res.data.error_msg[0].msg} (${res.data.error_msg[0].value})`,
                      false
                    )
                  } else {
                    console.log('HERE 3')
                    xFlag = true
                  }
                } else {
                  console.log('HERE 2')
                  xFlag = true
                }
              } else {
                console.log('HERE 1')
                xFlag = true
              }

              if (xFlag) {
                this.showMsgDialog(
                  'error',
                  'Invalid input, Parameter value has problem',
                  false
                )
              }
            } else {
              this.showMsgDialog('error', res.data.status_msg, false)
            }
          }
          this.$emit('loadPage')
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    remove(pItem, index) {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin menghapus item ini ?',
        true
      ).then((res) => {
        if (res.isConfirmed) {
          this.form.items.splice(index, 1)
        }
      })
    },
    removeAll() {
      if (this.form.items.length > 0) {
        this.showMsgDialog(
          'question',
          'Anda yakin ingin menghapus semua item dibawah ini ?',
          true
        ).then((res) => {
          if (res.isConfirmed) {
            this.form.items = []
          }
        })
      } else {
        this.showMsgDialog('warning', 'Tidak ada item untuk dihapus', false)
      }
    },
    clear() {
      this.form = {
        destination: null,
        schedule_from: '',
        schedule_to: '',
        description: '',
        items: [],

        total_item: 0
      }
      this.$refs.assetDocUpload.reset()
    },

    uploadFile(event) {
      if (event != null) {
        this.isUpload = true
        const data = new FormData()
        data.append('file', event)
        axios
          .post(`${this.upload}esanqua/ams/sale_document`, data)
          .then((res) => {
            if (res.data.status == true) {
              // this.showMsgDialog('success', res.data.message, false)
              this.uploadMessage = ['success', res.data.message, 'green']
              this.form.sales_document = res.data.data.name
            } else if (res.data.status == false) {
              // this.showMsgDialog('warning', res.data.message, false)
              this.uploadMessage = ['warning', res.data.message, 'orange']
              this.$refs.assetDocUpload.reset()
            } else {
              // this.showMsgDialog('warning', res.data.message, false)
              this.uploadMessage = ['warning', res.data.message, 'orange']
              this.$refs.assetDocUpload.reset()
            }
            this.isUpload = false
            setTimeout(() => {
              this.uploadMessage = []
            }, 10000)
          })
          .catch((err) => {
            console.log(err)
            // this.showMsgDialog(
            //   'error',
            //   err
            //     ? 'Something went wrong, Please contact an admin!'
            //     : 'Something went wrong, Please contact an admin!',
            //   false
            // )
            this.uploadMessage = [
              'error',
              'Something went wrong, Please contact an admin!',
              'red'
            ]
            this.isUpload = false
            this.$refs.assetDocUpload.reset()
            setTimeout(() => {
              this.uploadMessage = []
            }, 10000)
          })
      } else {
        this.form.sales_document = ''
      }
    }
  }
}
</script>
